
document.addEventListener('DOMContentLoaded', () => {

  const recipe = {};

const searchInput = document.getElementById('ingredient-search');

let ingredientRows = [];

const ingredientList =
    document.getElementById('ingredient-list');

const recipeItemsContainer = document.getElementById('recipe-items');

const totalWeightEl = document.getElementById('total-weight');
const ingredientsCostEl = document.getElementById('ingredients-cost');
const roastingCostEl = document.getElementById('roasting-cost');
const grandTotalEl = document.getElementById('grand-total');
const recipeTotalEl = document.getElementById('recipe-total');
const youSaveEl = document.getElementById('you-save');
const addToCartBtn = document.getElementById('add-to-cart-btn');
const builderMessage = document.getElementById('builder-message');

const roastingReminder =
    document.getElementById('roasting-reminder');

const roastingCharge =
    Number(window.masalaBuilder?.roastingCharge || 0);

function showMessage(message){
  if(!builderMessage) return;
  builderMessage.textContent=message;
  builderMessage.classList.add('show');
}

function hideMessage(){
  if(!builderMessage) return;
  builderMessage.textContent='';
  builderMessage.classList.remove('show');
}

async function loadIngredients(){

    const response = await fetch(
        `/collections/${window.masalaIngredientCollection.handle}/products.json?limit=${window.masalaIngredientCollection.limit}`
    );

    const data = await response.json();
    console.log(data);

    let html='';

    data.products.forEach(product=>{

let price250 = 0;

const variant250 = product.variants.find(v => {

    // Match by title
    if (v.title) {

        const title = v.title
            .replace(/\s+/g, '')
            .toLowerCase();

        if (
            title === '250'
            || title === '250g'
            || title === '250gm'
            || title === '250G'
            || title === '250GM'
            || title === '250grams'
        ) {
            return true;
        }
    }

    // Match by option values
    if (Array.isArray(v.options)) {

        return v.options.some(option => {

            const value = String(option)
                .replace(/\s+/g, '')
                .toLowerCase();

            return (
                value === '250'
                || value === '250g'
                || value === '250gm'
                || title === '250G'
                || title === '250GM'
                || value === '250grams'
            );

        });

    }

    return false;

});

if (variant250) {

    price250 = parseFloat(variant250.price);

}

        html+=`

<div
class="ingredient-row"
data-name="${product.title.toLowerCase()}"
data-product-id="${product.id}"
data-price-per-gram="${(price250 / 250).toFixed(6)}"
>

<div class="ingredient-image">

${
product.images.length
?
`<img
    src="${product.images[0].src}"
    width="100"
    height="100"
    loading="lazy"
    alt="${product.title}"
>`
:
''
}

</div>

<div class="ingredient-name">

${product.title}

</div>

<div class="ingredient-qty">

<button
type="button"
class="qty-minus"
>

−

</button>

<input
type="number"
class="qty-input"
min="0"
step="1"
value="0"
>

<button
type="button"
class="qty-plus"
>

+

</button>

<span class="grams-label">

g

</span>

</div>

</div>

`;

    });

    console.log(html.length);
    ingredientList.innerHTML=html;
    

    ingredientRows=[
        ...document.querySelectorAll('.ingredient-row')
    ];
    console.log(ingredientRows.length);

    initialiseIngredientEvents();

}


function initialiseIngredientEvents(){

    ingredientRows.forEach(row=>{

        const minusBtn=row.querySelector('.qty-minus');
        const plusBtn=row.querySelector('.qty-plus');
        const input=row.querySelector('.qty-input');

        minusBtn.addEventListener('click',()=>{

            let value=parseInt(input.value||0);

            value=Math.max(0,value-1);

            input.value=value;

            updateIngredient(row);

        });

        plusBtn.addEventListener('click',()=>{

            let value=parseInt(input.value||0);

            value++;

            input.value=value;

            updateIngredient(row);

        });

        input.addEventListener('input',()=>{

            if(input.value<0){

                input.value=0;

            }

            updateIngredient(row);

        });

    });

}

/* ------------------------------
   SEARCH
------------------------------ */

searchInput?.addEventListener('input',function(){

    const searchTerm=this.value.toLowerCase();

    ingredientRows.forEach(row=>{

        row.style.display=
            row.dataset.name.includes(searchTerm)
            ?''
            :'none';

    });

});

 

  /* ------------------------------
     UPDATE INGREDIENT
  ------------------------------ */

  function updateIngredient(row) {

    const productId = row.dataset.productId;
    const name = row.dataset.name;
    const displayName =
      row.querySelector('.ingredient-name').textContent.trim();

    const grams =
      parseInt(row.querySelector('.qty-input').value || 0);

const pricePerGram =
    parseFloat(row.dataset.pricePerGram || 0);

    if (grams <= 0) {

      delete recipe[productId];

    } else {

      recipe[productId] = {
        id: productId,
        name: displayName,
        grams: grams,
        roast: 'non-roasted',
        pricePerGram: pricePerGram
      };

    }

    renderRecipe();

  }

  /* ------------------------------
     RENDER RECIPE
  ------------------------------ */

  function renderRecipe() {

    hideMessage();

    const items = Object.values(recipe);

    if (roastingReminder) {

    roastingReminder.classList.toggle(
        'show',
        items.length > 0
    );

}

    if (!items.length) {

      recipeItemsContainer.innerHTML =
        '<div class="empty-recipe">No ingredients selected</div>';

      totalWeightEl.textContent = '0g';
      ingredientsCostEl.textContent = '₹0';
      roastingCostEl.textContent = '₹0';
      grandTotalEl.textContent = '₹0';

      return;
    }

    let html = '';

    let totalWeight = 0;
    let ingredientsCost = 0;
    let roastingApplied = false;

    items.forEach(item => {

      totalWeight += item.grams;

      ingredientsCost +=
        item.grams * item.pricePerGram;

      if (item.roast === 'roasted') {
        roastingApplied = true;
      }

      html += `
        <div class="recipe-item">

          <div class="recipe-item-name">
            ${item.name}
          </div>

          <select
            class="recipe-item-select"
            data-id="${item.id}"
          >
            <option value="non-roasted"
              ${item.roast === 'non-roasted' ? 'selected' : ''}
            >
              Non Roasted
            </option>

            <option value="roasted"
              ${item.roast === 'roasted' ? 'selected' : ''}
            >
              Roasted
            </option>

          </select>

          <div class="recipe-item-weight">
            ${item.grams}g
          </div>

          <button
            class="remove-item"
            data-id="${item.id}"
          >
            ×
          </button>

        </div>
      `;

    });

    const roastingCost =
      roastingApplied ? roastingCharge : 0;

const recipeTotal =
  ingredientsCost + roastingCost;

/* Round down to nearest ₹50 */

const payableAmount =
  Math.floor(recipeTotal / 50) * 50;

const savings =
  recipeTotal - payableAmount;

    recipeItemsContainer.innerHTML = html;

    totalWeightEl.textContent =
      `${totalWeight}g`;

    ingredientsCostEl.textContent =
      `₹${ingredientsCost.toFixed(2)}`;

    roastingCostEl.textContent =
      `₹${roastingCost.toFixed(2)}`;

recipeTotalEl.textContent =
  `₹${recipeTotal.toFixed(2)}`;

youSaveEl.textContent =
  `₹${savings.toFixed(2)}`;

grandTotalEl.textContent =
  `₹${payableAmount.toFixed(2)}`;

    attachRecipeEvents();

  }

  /* ------------------------------
     RECIPE EVENTS
  ------------------------------ */

  function attachRecipeEvents() {

    document
      .querySelectorAll('.recipe-item-select')
      .forEach(select => {

        select.addEventListener('change', function () {

          const id = this.dataset.id;

          recipe[id].roast = this.value;

          renderRecipe();

        });

      });

    document
      .querySelectorAll('.remove-item')
      .forEach(button => {

        button.addEventListener('click', function () {

          const id = this.dataset.id;

          delete recipe[id];

          const sourceRow =
            document.querySelector(
              `.ingredient-row[data-product-id="${id}"]`
            );

          if (sourceRow) {
            sourceRow.querySelector('.qty-input').value = 0;
          }

          renderRecipe();

        });

      });

  }




/* ------------------------------
   ADD TO CART FINAL
------------------------------ */

const BLEND_PRODUCT_VARIANTS = {
  50:43340340461616,100:43340364939312,150:43340364972080,200:43340365004848,250:43340365037616,
  300:43340365070384,350:43340365103152,400:43340365135920,450:43340365168688,500:43340365201456,
  550:43340365234224,600:43340365266992,650:43340365299760,700:43340365332528,750:43340365365296,
  800:43340365398064,850:43340365430832,900:43340365463600,950:43340365496368,1000:43340365529136,
  1050:43340365561904,1100:43340365594672,1150:43340365627440,1200:43340365660208,1250:43340365692976,
  1300:43340374671408,1350:43340374704176,1400:43340374736944,1450:43340374769712,1500:43340374802480,
  1550:43340374835248,1600:43340374868016,1650:43340374900784,1700:43340374933552,1750:43340374966320,
  1800:43340374999088,1850:43340375031856,1900:43340375064624,1950:43340375097392,2000:43340375130160,
  2050:43340375162928,2100:43340375195696,2150:43340375228464,2200:43340375261232,2250:43340375294000,
  2300:43340375326768,2350:43340375359536,2400:43340375392304,2450:43340375425072,2500:43340375457840,
  2550:43340376670256,2600:43340376703024,2650:43340376735792,2700:43340376768560,2750:43340376801328,
  2800:43340376834096,2850:43340376866864,2900:43340376899632,2950:43340376932400,3000:43340376965168,
  3050:43340376997936,3100:43340377030704,3150:43340377063472,3200:43340377096240,3250:43340377129008,
  3300:43340377161776,3350:43340377194544,3400:43340377227312,3450:43340377260080,3500:43340377292848,
  3550:43340377325616,3600:43340377358384,3650:43340377391152,3700:43340377423920,3750:43340377456688,
  3800:43340377784368,3850:43340377817136,3900:43340377849904,3950:43340377882672,4000:43340377915440,
  4050:43340377948208,4100:43340377980976,4150:43340378013744,4200:43340378046512,4250:43340378079280,
  4300:43340378112048,4350:43340378144816,4400:43340378177584,4450:43340378210352,4500:43340378243120,
  4550:43340378275888,4600:43340378308656,4650:43340378341424,4700:43340378374192,4750:43340378406960,
  4800:43340378439728,4850:43340378472496,4900:43340378505264,4950:43340378538032,5000:43340378570800
};

if (addToCartBtn) {
  addToCartBtn.addEventListener('click', async () => {
    const items = Object.values(recipe);
    if (!items.length) {
      showMessage('Please add at least one ingredient.');
      return;
    }

    /* ------------------------------
   VALIDATION
------------------------------ */

// Total Weight
const totalWeight =
  parseInt(totalWeightEl.textContent.replace('g',''));

// Payable Amount
const payableAmount =
  parseFloat(
    grandTotalEl.textContent.replace(/[₹,]/g,'')
  );

// Minimum Weight
if (totalWeight < 1000) {

  showMessage('Minimum masala blend weight should be 1000g. Please add more ingredients to continue.');

  return;

}

// Maximum Blend Value
if (payableAmount > 5000) {

  showMessage('Maximum blend amount is ₹5000. Please reduce the ingredient quantities to continue.');

  return;

}

    const variantId = BLEND_PRODUCT_VARIANTS[payableAmount];

    if (!variantId) {
      alert('Blend Value variant not found for ₹' + payableAmount);
      return;
    }

    const recipeName = document.getElementById('recipe-name')?.value?.trim() || 'Custom Masala Blend';

    
const recipeId = 'MASALA-' + Date.now();

const properties = {

  // Header
  'Recipe Name': recipeName,
  'Recipe ID': recipeId,

  // Ingredients
  'Ingredient Count': items.length

};

// Add ingredients immediately after the count
items.forEach((item, index) => {

  properties[`Ingredient ${index + 1}`] =
    `${item.name} | ${item.grams}g | ${item.roast}`;

});

// Add summary at the end
properties['Total Weight'] = totalWeightEl.textContent;
properties['Ingredients Cost'] = ingredientsCostEl.textContent;
properties['Roasting Charge'] = roastingCostEl.textContent;
properties['Recipe Total'] = recipeTotalEl.textContent;
properties['You Save'] = youSaveEl.textContent;
properties['Payable Amount'] = grandTotalEl.textContent;

    const response = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        items:[{id:variantId,quantity:1,properties}]
      })
    });

if(response.ok){

  const data = await response.json();
  console.log(data);

  window.location.href='/cart';

} else {

  const errorText = await response.text();

  console.log(errorText);

  showMessage(errorText);

}
  });
}

loadIngredients();

});